import React from 'react';
import { IDrawerConfig } from '../../components/customDrawer';

interface IDrawerContext {
	drawerConfig: IDrawerConfig;
	setDrawerConfig: React.Dispatch<
		React.SetStateAction<{
			isOpen: boolean;
			content?: React.ReactChild;
		}>
	>;
}

const DrawerContext = React.createContext<IDrawerContext>({} as IDrawerContext);

export default DrawerContext;
